import './ToggleSwitch.scss';

import * as React from 'react';

import cx from 'classnames';

import { FocusIndicator } from '~shared/components/FocusIndicator/FocusIndicator';

export interface Props {
  on?: boolean;
  disabled?: boolean;
  onChange: (
    checked: boolean,
    value?: string,
    event?: React.ChangeEvent<HTMLInputElement>
  ) => void;
  id?: string;
  label?: string;
  labelledBy?: string;
  describedBy?: string;
  size?: 'small' | 'default';
  autoFocus?: boolean;
}

export default class ToggleSwitch extends React.PureComponent<Props> {
  public static defaultProps = {
    on: false,
    disabled: false,
    onChange: () => {},
    size: 'default',
  };

  constructor(props: Props) {
    super(props);
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { on, disabled, onChange } = this.props;

    disabled ? onChange(on) : onChange(event.currentTarget.checked);
  };

  setLabelAttribute = (
    {
      label,
      labelledBy,
      describedBy,
    } = this.props
  ) => {
    return {
      'aria-label': label,
      'aria-labelledby': labelledBy,
      'aria-describedby': describedBy,
    };
  };

  render() {
    const { on: checked, disabled, id, size, autoFocus } = this.props;
    const toggleSwitchClass = cx(
      'relative inline-block align-middle rounded-pill toggle-switch',
      {
        'is-checked': checked,
        'cursor-pointer': !disabled,
        'cursor-not-allowed': disabled,
        'toggle-switch--small': size === 'small',
      }
    );
    const switchTrackClass = cx(
      'relative flex rounded-pill transition duration-200 ease-in-out',
      'toggle-switch__track',
      {
        'opacity-66': disabled,
        'bg-grey-500': !checked,
        'bg-green-500': checked,
        'w-16 h-10': size === 'default',
        'w-14 h-8': size === 'small',
      }
    );

    return (
      <label className={toggleSwitchClass}>
        <FocusIndicator />
        <input
          className="sr-only toggle-switch__input"
          id={id}
          type="checkbox"
          checked={checked}
          aria-disabled={disabled}
          onChange={this.handleChange}
          autoFocus={autoFocus}
          {...this.setLabelAttribute()}
        />
        <div className={switchTrackClass}>
          <div className="flex w-full transition duration-200 ease-in-out toggle-switch__control">
            <div className="bg-white rounded-round toggle-switch__handle"></div>
          </div>
        </div>
      </label>
    );
  }
}
